<div class="main-container" [class.home-page]="isHome" [class.detail-page]="isDetail">

  <app-install-banner
    [show]="showBanner"
    [isIOS]="bannerIsIOS"
    [isAndroid]="bannerIsAndroid"
    (dismissed)="onBannerDismissed($event)">
  </app-install-banner>

  <div class="content">
    <router-outlet />
  </div>

  <app-footer></app-footer>

</div>


